import React from 'react'
import '../App.css'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ChannelName from '../component/ChannelName'
import Videos from '../component/Videos'
import { fetchFromAPI } from '../utils/fetchFromApi'




const ChannelDetail = () => {
  
  const[channelDetail,setChannelDetail]=useState(null)
  const [videos,setVideos]=useState([])

  const {id}=useParams();

  console.log(channelDetail, videos);
  useEffect(()=>{
    fetchFromAPI(`channels?part=snippet&id=${id}`)
    .then((data)=>setChannelDetail(data?.items[0]))

    fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`)
    .then((data)=>setVideos(data?.items))

  },[id])
 
  return (
    <>
      <div className="container-fluid p-0" style={{height:"100vh"}}>
        <div className="row m-0 " >
          <div className="col p-0 " >
            <div className='channelDetails'></div>

            <div>
              <Videos videos={videos} />
            </div>
            
          </div>

        </div>
      </div>
    </>
  )
}

export default ChannelDetail
